import { gql } from '@apollo/client';
export const DISCARD_FEEDBACK_MUTATION = gql `
  mutation DiscardReviewFeedback($feedbackId: UUID!) {
    rejectReviewFeedback(reviewFeedbackId: $feedbackId) {
      id
      status
    }
  }
`;
